.layout {
  display: grid;
  grid-template-columns: 232px minmax(0, 1fr);
  gap: var(--space-8);
  align-items: start;
}

.nav ul {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
  position: sticky;
  inset-block-start: var(--space-6);
}

.navLink {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-block-size: 44px;
  padding-inline: var(--space-3);
  border-radius: var(--radius-s);
  color: var(--color-text-muted);
  font-weight: 500;
  text-decoration: none;
}

.navLink svg {
  inline-size: 18px;
  block-size: 18px;
}

.navLink:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.navLink[aria-current="page"] {
  background: var(--color-accent-subtle);
  color: var(--color-on-accent-subtle);
  font-weight: 600;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  min-inline-size: 0;
}

.who {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-header-text);
}

.who button {
  color: var(--color-header-text);
}

.pageHead {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
}

.pageTitle {
  font-family: var(--font-display);
  font-weight: 500;
  font-size: var(--text-2xl);
}

.pageLead {
  color: var(--color-text-muted);
  max-inline-size: 70ch;
  margin-block-start: var(--space-1);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.cellMain {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cellMain > :first-child {
  font-weight: 600;
}

.muted {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  direction: ltr;
  unicode-bidi: isolate;
}

.linkButton {
  padding: 0;
  border: 0;
  background: none;
  color: var(--color-accent);
  font: inherit;
  font-weight: 600;
  text-align: start;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.grid2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: var(--space-4);
}

.kv {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-6);
  margin: 0;
}

.kv dt {
  color: var(--color-text-muted);
}

.kv dd {
  margin: 0;
  font-weight: 500;
  overflow-wrap: anywhere;
}

@media (width <= 900px) {
  .layout {
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }

  .nav ul {
    position: static;
    flex-flow: row wrap;
  }
}

.kvRow {
  display: contents;
}

.sessionList {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.sessionItem {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding-block: var(--space-3);
  border-block-end: 1px solid var(--color-border);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.back {
  margin-block-end: calc(-1 * var(--space-4));
}
